var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.336,
    height: 22.337,
    viewBox: "0 0 22.336 22.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3649087"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3221",
    "data-name": "Rectangle 3221",
    width: 22.336,
    height: 22.337,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98445",
    "data-name": "Group 98445",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10069",
    "data-name": "Group 10069",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3649087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13063",
    "data-name": "Path 13063",
    d: "M11.2,14.932A3.733,3.733,0,1,1,14.932,11.2,3.733,3.733,0,0,1,11.2,14.932m0-5.6A1.866,1.866,0,1,0,13.065,11.2,1.866,1.866,0,0,0,11.2,9.332m5.6,12.132a5.6,5.6,0,1,0-11.2,0,.933.933,0,0,0,1.866,0,3.733,3.733,0,1,1,7.466,0,.933.933,0,1,0,1.866,0m0-14a3.733,3.733,0,1,1,3.733-3.733A3.733,3.733,0,0,1,16.8,7.466m0-5.6a1.866,1.866,0,1,0,1.866,1.866A1.866,1.866,0,0,0,16.8,1.866M22.4,14a5.6,5.6,0,0,0-5.6-5.6.933.933,0,0,0,0,1.866A3.733,3.733,0,0,1,20.531,14,.933.933,0,1,0,22.4,14M5.6,7.466A3.733,3.733,0,1,1,9.332,3.733,3.733,3.733,0,0,1,5.6,7.466m0-5.6A1.866,1.866,0,1,0,7.466,3.733,1.866,1.866,0,0,0,5.6,1.866M1.866,14A3.733,3.733,0,0,1,5.6,10.265.933.933,0,1,0,5.6,8.4,5.6,5.6,0,0,0,0,14a.933.933,0,0,0,1.866,0",
    transform: "translate(-0.061 -0.061)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuIcon);
export default __webpack_public_path__ + "static/media/team-menu-icon.7a775d0c566da4480053383038d57211.svg";
export { ForwardRef as ReactComponent };